import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { priceShow } from 'shared/lib/priceShow'

import { MBonusIcons } from '../mbonus-icons'

import s from './styles.module.scss'

type Props = {
  price: string | undefined
}

const MBonusLine = ({ price }: Props) => {
  const { t } = useTranslation()

  if (!parseInt(price || '0')) {
    return
  }

  return (
    <div className={s.mbonusWrapper}>
      <p className={clsx(s.description, 'regular-14')}>{t('cashback')}</p>

      <MBonusIcons text={priceShow(price)} />
    </div>
  )
}

export default MBonusLine
